import styled, { css } from "styled-components/macro";
import { device } from "../../device";

export const StyledMainContainer = styled.div`
	width: 100%;
	transition: 0.5s; /* 0.5 second transition effect to slide in the sidenav */

	${({ sidebarExpended }) =>
		sidebarExpended &&
		css`
			padding-left: 12rem;
		`}
	${({ showNav }) =>
		!showNav &&
		css`
			padding-left: 0;
		`}
	font-family: Poppins;
`;

export const StyledInnerContainer = styled.div`
	width: 100%;
	margin: auto;
	padding: 0.5rem 5px;
	transition: 0.5s; /* 0.5 second transition effect to slide in the sidenav */

	max-width: 1200px;
	@media ${device.tablet} {
		padding: 0.5rem;
		overflow-x: hidden;
	}

	@media ${device.mobileL} {
		padding: 0.5rem;
		overflow-x: hidden;
	}
`;
